import React, {useEffect, useState} from "react";
import {useHistory, useLocation, useParams} from "react-router-dom";
import Blocks from "../blocks";

import studyLogin from "../../assets/images/study-login.svg";
import {useMutation, useQueryClient} from "react-query";
import {createClassPlan} from "../../api/classPlan";
import _ from 'lodash';
import {getClassDetailsById} from "../../utils/reactQueries";
import {IoMdArrowBack} from "react-icons/io"

const PageInitializeClassPlan = () => {

    const history = useHistory();
    const location = useLocation();
    const user = location.pathname.split("/")[1];
    const params = useParams();
    const queryClient = useQueryClient()
    const classId = params.classId;
    const [isClassLoading, _isClassLoading] = useState(false);
    const [classDetails, setClassDetails] = useState(null);

    /** get class details */

    const {status, data: classData, error: classError, isFetching} = getClassDetailsById(classId);

    useEffect(()=> {
        queryClient.refetchQueries('getClassById');
    }, []);

    useEffect(() => {
        const data = classData?.data;
        if (data) {
            setClassDetails(data);
        }
    }, [classData]);

    /** add content to the current playlist*/
    const {
        mutate: createNewClassPlan,
    } = useMutation(createClassPlan, {
        onSuccess: (data, variables) => {
            _isClassLoading(false);
            if (data.status === 201) {
                const classPlanID = data?.data?.body?.id;
                if (classPlanID) {
                    localStorage.setItem('classPlanID', classPlanID);
                    history.push(`/class/${classId}/class-plan/${classPlanID}`);
                }
            }
        },
        onError: (err) => {
            console.log(err);
            alert("Something Went wrong...");
        },
    });
    const handleSubmit = () => {
        const hashClassPlanId = classDetails?.classPlan?.id;
        if (hashClassPlanId) {
            history.push(`/class/${classId}/class-plan/${hashClassPlanId}`);
        } else {
            if (!_.isNull(classDetails)) {
                _isClassLoading(true);
                const data = {
                    "title": classDetails?.title,
                    "description": "",
                }
                createNewClassPlan({classPlanData: data, classID: classDetails?.id});
            } else {
                alert("class Data not found")
            }
        }
    }

    const goToAddStudents = () => {
        history.push(`/class/${classId}/add-students`)
    }

    const goToEditVirtualClass = () => {
        localStorage.setItem("classId", classId);
        history.push(`/create-virtual-class/${classId}/edit?back=true`);
    }

    return (
      <>
        <div className="page pageStartLiveClass">
          <div className="container mx-auto">
            <div className="flex flex-col md:flex-row items-center">
              <div className="flex md:hidden    justify-center items-center gap-2">
                <div className="pt-12" onClick={() => goToEditVirtualClass()}>
                  <IoMdArrowBack size={25} className="mr-3 cursor-pointer" />
                </div>
                <h3
                  className={
                    "text-xl text-center pt-16 pb-4 font-['Poppins-Bold']"
                  }
                >
                  Create your class plan
                </h3>
              </div>

              <div className="left-section bgWrapper">
                <img src={studyLogin} alt="" draggable={false} />
              </div>
              <div className="right-section flex items-center justify-center w-full max-w-3xl ml-auto ">
                <div className={"block BlockLiveClasses w-full sm:max-w-3xl"}>
                  <div className="w-full p-4">
                    <div className="hidden md:flex  justify-center items-center gap-2">
                      <div onClick={() => goToEditVirtualClass()}>
                        <IoMdArrowBack
                          size={40}
                          className="mr-3 cursor-pointer"
                        />
                      </div>
                      <div className=" w-full text-4xl font-['Poppins-Bold'] mx-auto mb-2">
                        Create your class plan
                      </div>
                    </div>

                    <Blocks.ErrorBoundary>
                      <div className="classList w-full max-h-screen overflow-scroll px-1 py-2 lg:mt-12">
                        {user === "teacher" && (
                          <Blocks.BlockTeacherCreatePlan />
                        )}
                      </div>
                      {user === "teacher" && (
                        <div className="flex justify-center items-center flex-col">
                          <button
                            // onClick={() => redirectCreatePlan()}
                            disabled={isClassLoading}
                            onClick={() => handleSubmit()}
                            className={`w-4/5 bg-black hover:bg-slate-600 text-white font-bold py-2 px-8 rounded-lg focus:outline-none focus:shadow-outline flex justify-center items-center`}
                            type="button"
                          >
                            Create your class plan
                          </button>
                          <span className="mt-5 mb-5 text-base">or</span>
                          <h6
                            onClick={() => goToAddStudents()}
                            className="underline italic cursor-pointer text-sm"
                          >
                            Skip this and add students
                          </h6>
                        </div>
                      )}
                    </Blocks.ErrorBoundary>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}
export default PageInitializeClassPlan;
